import * as React from 'react'
import {OEMLIST} from './oemConfig'

const initialState = {
	oem: {},
    plainOptions: [],
    indeterminate: true,
    checkAll: false,
    visible: false
}	

type State = Readonly<typeof initialState>

const oemSetMethod = (Wrapper) =>

    class WrapperComponent extends React.Component<any, State>{
        public readonly state: State = initialState
        
        componentWillMount() {
            const oemDetail = this.setOem()
            this.setState({
                oem: {oemDetail}
            })
        }
        //  设置 title favicon 和oem登录界面
        setOem = () => {
            const hostName = location.host
            // 默认的oem
            let defaultOem = OEMLIST[0]

            OEMLIST.some(item => {
                if (item.url.indexOf(hostName) > -1) {
                    defaultOem = item
                    return true
                }
                return false
            })
            this.setTitleFav(defaultOem)
            return defaultOem
        }
        //  设置 title favicon 方法
        setTitleFav = (target) => {
            document.title = target.title
            if (target.favicon) {
                this.setFavicon(target.favicon)
            }

            const footer = document.getElementById('footer')
            if (footer) {
                footer.innerText = target.footerText
            }

        }
        
        setFavicon = (faviconUrl) => {
            const linkDom: any = document.querySelector('link[rel="shortcut icon"]')

            linkDom.href = faviconUrl
            // const docHead = document.getElementsByTagName('head')[0]
            // const newLink = document.createElement('link')
            // newLink.rel = 'shortcut icon'
            // newLink.type = 'image/x-icon'
            // newLink.href = faviconUrl
            // docHead.appendChild(newLink)
        }

        getOemVal = (key) => {
            const {oemDetail} = this.state.oem as any
            if (key in oemDetail) {
                return oemDetail[key]
            }
            if ('order' in oemDetail) {
                if (key in oemDetail.order) {
                    return oemDetail.order[key]
                }
            }
            return false
        }
        render() {
            const {oemDetail} = this.state.oem as any
            return (
                <Wrapper
                    {...this.props}
                    oemDetail={oemDetail}
                    getOemVal={this.getOemVal}
                />
            )
        }
    }

export default oemSetMethod
